import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../axiosInstance";

// Define an async thunk to fetch data from the API

const token = localStorage.getItem("accessToken"); // Assuming token is stored in localStorage


export const fetchProfileData = createAsyncThunk(
  "viewprofile",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/auth/${id}/`,{
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, // Passing token here
        }
      });

    
      return response.data;
    } catch (error) {
      // Handle errors appropriately
      return rejectWithValue(
        error.response ? error.response.data : "An error occurred"
      );
    }
  }
);
